

import { SET_ACCESS_LEVEL } from "../contents/actionsTypes"

export const setAccessLevel = (level) => {
    return ({type: SET_ACCESS_LEVEL, payload: level})
  }
  